const URLASSOLUTO = window.URLASSOLUTO;
const URLASSOLUTOISTITUZIONALE = window.URLASSOLUTOISTITUZIONALE;
const TEMPLATEID = window.TEMPLATEID;
const CURRENTROUTENAME = window.CURRENTROUTENAME;
const VIEWNAME = window.VIEWNAME;
const TITLELOADER = window.TITLELOADER;
const TEXTLOADER = window.TEXTLOADER;
delete window.URLASSOLUTO;
delete window.URLASSOLUTOISTITUZIONALE;
delete window.CURRENTROUTENAME;
delete window.TEMPLATEID;
delete window.VIEWNAME;
delete window.METATEMPLATEALTERNATE;

export { URLASSOLUTO, URLASSOLUTOISTITUZIONALE, CURRENTROUTENAME, VIEWNAME, TEMPLATEID, TITLELOADER, TEXTLOADER };
